// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2tnFf","location":"Header_location__1RZ4n"};